const btn = document.querySelector('#btn-side-menu')
const close = document.querySelector('#btn-close-side-menu')
const menu = document.querySelector('#side-menu')

if (!btn) {
  return
}

btn.addEventListener('click', () => toggleSearch())

function toggleSearch() {
  const hidden = menu.getAttribute('aria-hidden') === 'true'
  menu.setAttribute('aria-hidden', hidden ? 'false' : 'true')
}

close.addEventListener('click', () => {
  menu.setAttribute('aria-hidden', 'true')
})
